<div class="session">
  <div class="session-content text-xs-center">
    <div>
      <div class="error-title">{{'NO_INTERNET' | translate}}!</div>
      <div class="error-subtitle">{{'CHECK_INTERNET_CONNECTION' | translate}}.</div>
      <br>
      <button (click)="gotoHome()" mat-flat-button color="accent">{{'TRY_AGAIN' | translate}}</button>
    </div>
  </div>
</div>